
import jsPDF from "jspdf";

export function generateQRCodeSheet({ canvas, month, code, expires, format = "letter" }) {
  if (!canvas) {
    console.error("QR canvas not found");
    return;
  }

  const dataURL = canvas.toDataURL("image/png");
  const doc = new jsPDF({ unit: "pt", format });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const cols = 3;
  const rows = 4;
  const margin = 36;
  const gutter = 12;

  const contentW = pageW - margin * 2;
  const contentH = pageH - margin * 2;
  const tileW = (contentW - gutter * (cols - 1)) / cols;
  const tileH = (contentH - gutter * (rows - 1)) / rows;

  const navy = [0, 32, 96];

  const [year, mon] = month.split("-");
  const displayMonth = new Date(+year, +mon - 1).toLocaleString("default", { month: "long" });
  const title = `${displayMonth} ${year}`;

  // Page Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0);
  doc.text("BCSW Amarra – Gate Access QR Codes", pageW / 2, margin - 12, { align: "center" });

  // Crop lines
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  if (doc.setLineDash) doc.setLineDash([3, 3], 0);

  for (let r = 1; r < rows; r++) {
    const y = margin + r * tileH + (r - 1) * gutter + gutter / 2;
    doc.line(margin, y, pageW - margin, y);
  }
  for (let c = 1; c < cols; c++) {
    const x = margin + c * tileW + (c - 1) * gutter + gutter / 2;
    doc.line(x, margin, x, pageH - margin);
  }
  doc.line(margin, margin, pageW - margin, margin);
  doc.line(margin, pageH - margin, pageW - margin, pageH - margin);
  doc.line(margin, margin, margin, pageH - margin);
  doc.line(pageW - margin, margin, pageW - margin, pageH - margin);

  if (doc.setLineDash) doc.setLineDash([], 0);

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const x = margin + c * (tileW + gutter);
      const y = margin + r * (tileH + gutter);

      const qrSize = tileW * 0.5;
      const qrX = x + (tileW - qrSize) / 2;
      const qrY = y + 36;

      // Blue panel background
      const panelH = qrSize + 28;
      const panelW = qrSize + 20;
      const panelX = qrX - 10;
      const panelY = qrY - 10;

      doc.setFillColor(...navy);
      doc.roundedRect(panelX, panelY, panelW, panelH, 6, 6, "F");

      // QR image
      doc.addImage(dataURL, "PNG", qrX, qrY, qrSize, qrSize);

      // SCAN ME
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(255, 255, 255);
      doc.text("Scan Me", qrX + qrSize / 2, qrY + qrSize + 15, { align: "center" });

      // Title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(...navy);
      doc.text(title, x + tileW / 2, y + 20, { align: "center" });

      // Combined Gate Code: [code] on same line and centered
      const codeY = qrY + qrSize + 20;
      const label = "Gate Code:";
      const spacing = 6;

      // Measure widths
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      const labelW = doc.getTextWidth(label);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      const codeW = doc.getTextWidth(code);

      const totalW = labelW + spacing + codeW;
      const startX = x + tileW / 2 - totalW / 2;

      // Draw "Gate Code:"
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      doc.setTextColor(0);
      doc.text(label, startX, codeY + 15);

      // Draw actual code
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor(...navy);
      doc.text(code, startX + labelW + spacing, codeY + 15);

      // Expiration
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      doc.setTextColor(0);
      doc.text(`Pass and Code expire ${expires}`, x + tileW / 2, codeY + 26, { align: "center" });
    }
  }

  // Disclaimer
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(100);
  doc.text("Private use only – Do not share gate codes publicly. For residents of BCSW Amarra.", pageW / 2, pageH - 12, { align: "center" });

  doc.save(`Gate_QR_Sheet_${month}.pdf`);
}